import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TableHead } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Button } from "@totalsoft/rocket-ui";
import { StyledHeaderCell, StyledTableRow } from 'components/common/Styles';
import { financialProductRuleCommissionModalVar, defaultFinancialProductRuleCommission } from './variables';

const FinancialProductRulesEditDetailsCommissionsTableHead = ({ canWrite, isSaved }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <StyledTableRow>
        <StyledHeaderCell colSpan={2}>{t("FinancialProduct.Details.Rules.Details.Commissions.Name")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Commissions.Percent")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Commissions.Value")}</StyledHeaderCell>
        <StyledHeaderCell>{t("FinancialProduct.Details.Rules.Details.Commissions.AppliedTo")}</StyledHeaderCell>
        <StyledHeaderCell align="right">
          <Button color="primary" variant="contained" startIcon={<AddIcon />} disabled={!isSaved || !canWrite} 
          onClick={() => financialProductRuleCommissionModalVar({ open: true, item: defaultFinancialProductRuleCommission })}>
            {t("Add")}
          </Button>
        </StyledHeaderCell>
      </StyledTableRow>
    </TableHead>
  );
};

FinancialProductRulesEditDetailsCommissionsTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
};

export default FinancialProductRulesEditDetailsCommissionsTableHead;
